/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Pedido } from 'src/app/models/Pedido';
import { PostItem } from 'src/app/models/PostItem';
import { PostPedido } from 'src/app/models/PostPedido';
import { environment as env } from '../../../../environments/environment';
import { FormProductos } from './pedido-state.service';

@Injectable({ providedIn: 'root' })
export class PedidoApiService {
  constructor(private http: HttpClient) {}

  pushToDb(item: PostPedido): Observable<unknown> {
    return this.http.post(`${env.apiUrl}/ventas/pedidos/new`, item, {
      params: { inPage: false },
    });
  }

  actualizarMayorista(pedidoId: number, item: PostPedido): Observable<unknown> {
    return this.http.post(`${env.apiUrl}/ventas/pedidos/${pedidoId}/actualizarMayorista`, item, {
      params: { inPage: false },
    });
  }

  pushItemsToDb(
    pedidoId: number,
    items: { item: PostItem; totales: any }[]
  ): Observable<{ [key: string]: any }> {
    const url = `${env.apiUrl}/ventas/pedidos/${pedidoId}/items`;
    const observables: { [key: string]: Observable<any> } = {};
    items.forEach(({ item, totales }) => {
      observables[item.titulo] = this.http
        .post(url, { item, totales }, { params: { inPage: false } })
        .pipe(first());
    });
    return forkJoin(observables);
  }

  removeItemFromDb(
    pedidoId: number,
    itemId: number,
    values: FormProductos
  ): Observable<any> {
    return this.http
      .post(
        `${env.apiUrl}/ventas/pedidos/${pedidoId}/items/${itemId}/remover`,
        { values },
        { params: { inPage: false } }
      )
      .pipe(first());
  }

  editItemInDb(
    pedidoId: number,
    previus: FormProductos,
    itemForPost: PostItem,
    totalesForPost: any
  ): Observable<any> {
    const url = `${env.apiUrl}/ventas/pedidos/${pedidoId}/items`;
    return forkJoin([
      this.http.post(
        `${url}/${previus.id}/remover`,
        { previus },
        { params: { inPage: false } }
      ),
      this.http.post(
        url,
        { item: itemForPost, totales: totalesForPost },
        { params: { inPage: false } }
      ),
    ]).pipe(first());
  }

  finalizar(pedido: Pedido | PostPedido): Observable<any> {
    return this.http.post(
      `${env.apiUrl}/ventas/pedidos/${pedido.id}/finalizar`,
      pedido,
      { params: { inPage: false } }
    );
  }

  actualizar(pedido: PostPedido): Observable<any> {
    return this.http.post(
      `${env.apiUrl}/ventas/pedidos/${pedido.id}/actualizar`,
      pedido,
      { params: { inPage: false } }
    );
  }

  actualizarDatos(pedidoId: number, observaciones: string): Observable<unknown> {
    return this.http.post(
      `${env.apiUrl}/ventas/pedidos/${pedidoId}/actualizarDatos`,
      { observaciones }
    );
  }
}
